module.exports = __webpack_public_path__ + "ce3e9d2b69ba95690bf9357d16afd55e.svg";